import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingcaerentalmumbai() {



    const cardData = {




keyword: "Wedding Car Rental Mumbai",

headingDescription: "Shreesha Tours & Travels offers premium Wedding Car Rental services in Mumbai for weddings, receptions, engagements, pre-wedding shoots, bridal entries, groom processions, destination weddings, and luxury event transportation. We provide chauffeur-driven luxury cars, premium sedans, SUVs, vintage-style vehicles, Innova Crysta, Tempo Travellers, Urbania, Mini Buses, and group transportation for family members and wedding guests. Our professional chauffeurs ensure punctual arrivals, well-maintained vehicles, elegant decorations on request, and a comfortable travel experience for every occasion. Whether your wedding is at a luxury hotel, banquet hall, beachside venue, convention center, farmhouse, or resort, Shreesha Tours & Travels provides customized wedding transportation packages with doorstep pickup, transparent pricing, flexible booking options, and 24/7 customer support to make your special day memorable and hassle-free.",

topPlaces: [
  {
    title: "The St. Regis Mumbai",
    description: "The St. Regis Mumbai is one of the city's most luxurious wedding venues, offering elegant ballrooms, premium banquet spaces, world-class hospitality, and stunning city skyline views. It is a preferred venue for grand weddings and celebrity celebrations."
  },
  {
    title: "The Taj Mahal Palace",
    description: "The Taj Mahal Palace overlooking the Gateway of India is one of Mumbai's most iconic luxury wedding destinations. Its royal architecture, grand banquet halls, and exceptional hospitality make it ideal for premium wedding ceremonies."
  },
  {
    title: "The Westin Mumbai Powai Lake",
    description: "Located beside the scenic Powai Lake, The Westin Mumbai Powai Lake offers luxurious indoor and outdoor wedding venues with beautiful lake views, spacious banquet halls, and premium hospitality services."
  },
  {
    title: "Grand Hyatt Mumbai",
    description: "Grand Hyatt Mumbai is one of the most sought-after wedding venues in the city, featuring magnificent banquet halls, landscaped lawns, luxurious accommodations, and exceptional event management facilities."
  },
  {
    title: "JW Marriott Mumbai Juhu",
    description: "JW Marriott Mumbai Juhu offers elegant beachfront wedding venues, luxurious banquet halls, premium hospitality, and breathtaking Arabian Sea views, making it a perfect venue for destination-style weddings."
  },
  {
    title: "NESCO Exhibition Centre, Goregaon",
    description: "NESCO Exhibition Centre is a popular venue for large-scale weddings, receptions, exhibitions, and grand celebrations. Its spacious event halls can accommodate thousands of guests comfortably."
  },
  {
    title: "MCA Club, Bandra Kurla Complex",
    description: "MCA Club at Bandra Kurla Complex is a premium venue offering spacious banquet halls, landscaped lawns, and excellent event facilities for weddings, receptions, and corporate celebrations."
  },
  {
    title: "Goregaon Film City",
    description: "Film City in Goregaon is a preferred destination for pre-wedding photography, cinematic wedding shoots, and luxurious wedding events surrounded by beautiful natural landscapes and film studio settings."
  },
  {
    title: "Lonavala",
    description: "Located around two hours from Mumbai, Lonavala is one of the most popular destination wedding locations featuring luxury resorts, scenic mountain views, beautiful villas, and premium wedding venues for intimate and grand celebrations."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a favorite destination wedding location near Mumbai, known for its luxury beach resorts, private villas, seaside venues, and peaceful coastal atmosphere. It is perfect for elegant beach weddings and weekend wedding celebrations."
  }
],



"services": [
  {
    "name": "Wedding Car Rental Mumbai",
    "description": "Book Wedding Car Rental Mumbai for elegant and comfortable wedding transportation with luxury chauffeur-driven vehicles. Choose from Mercedes, BMW, Audi, Jaguar, Innova Crysta, premium SUVs, and luxury sedans for bridal entry, groom arrival, wedding ceremonies, receptions, engagements, and other special occasions with professional drivers and beautifully maintained vehicles."
  },
  {
    "name": "Wedding Car Hire Mumbai",
    "description": "Choose Wedding Car Hire Mumbai for stylish and reliable transportation on your special day with experienced chauffeurs and premium luxury cars. Enjoy punctual service, decorated wedding vehicles, flexible rental packages, and comfortable travel for brides, grooms, family members, and wedding guests."
  },
  {
    "name": "Marriage Car Rental Mumbai",
    "description": "Reserve Marriage Car Rental Mumbai for luxurious wedding travel with chauffeur-driven premium vehicles. Select from luxury sedans, SUVs, Mercedes, BMW, Audi, Innova Crysta, and spacious family vehicles for wedding ceremonies, receptions, and all marriage-related events."
  },
  {
    "name": "Wedding Car Booking Mumbai",
    "description": "Complete Wedding Car Booking Mumbai with instant reservation, premium vehicle selection, and professional chauffeur service. Book elegant wedding cars for bridal entry, groom arrival, VIP guests, wedding processions, and reception events with customized rental packages."
  },
  {
    "name": "Luxury Wedding Car Rental Mumbai",
    "description": "Book Luxury Wedding Car Rental Mumbai for a grand wedding experience with premium chauffeur-driven vehicles including Mercedes, BMW, Audi, Jaguar, and luxury SUVs. Make your wedding day memorable with stylish transportation, professional service, and beautifully maintained luxury cars."
  },
  {
    "name": "Bridal Car Rental Mumbai",
    "description": "Choose Bridal Car Rental Mumbai for a beautiful and luxurious bridal entry with elegant chauffeur-driven vehicles. Enjoy premium comfort, stylish interiors, decorative options, and reliable transportation for weddings, receptions, engagements, and pre-wedding ceremonies."
  },
  {
    "name": "Groom Car Rental Mumbai",
    "description": "Book Groom Car Rental Mumbai with luxury cars and professional chauffeurs for a grand groom arrival. Choose premium sedans, luxury SUVs, Mercedes, BMW, Audi, or Innova Crysta vehicles for stylish and memorable wedding transportation."
  },
  {
    "name": "Wedding Taxi Service Mumbai",
    "description": "Hire Wedding Taxi Service Mumbai for reliable transportation of the bride, groom, family members, and wedding guests. Enjoy clean AC vehicles, experienced drivers, flexible booking options, and comfortable travel throughout your wedding celebrations."
  },
  {
    "name": "Wedding Chauffeur Service Mumbai",
    "description": "Reserve Wedding Chauffeur Service Mumbai with professionally trained drivers and premium vehicles for elegant wedding transportation. Experience punctual service, courteous chauffeurs, luxury comfort, and stress-free travel for every wedding event."
  },
  {
    "name": "Premium Car Rental Mumbai",
    "description": "Choose Premium Car Rental Mumbai for luxury chauffeur-driven vehicles suitable for weddings, corporate events, VIP travel, airport transfers, family celebrations, and special occasions. Enjoy premium comfort, stylish interiors, and exceptional service."
  },
  {
    "name": "Luxury Car Hire Mumbai",
    "description": "Book Luxury Car Hire Mumbai with premium vehicles including Mercedes, BMW, Audi, Jaguar, and luxury SUVs for weddings, receptions, business events, celebrity travel, and VIP transportation with experienced chauffeurs."
  },
  {
    "name": "Wedding Transportation Service Mumbai",
    "description": "Hire Wedding Transportation Service Mumbai for complete wedding travel solutions including luxury cars for the bride and groom, guest transportation, family vehicles, airport pickups, hotel transfers, and wedding venue transportation with professional drivers."
  },
  {
    "name": "Wedding Innova Rental Mumbai",
    "description": "Book Wedding Innova Rental Mumbai for spacious and comfortable transportation for family members and wedding guests. Enjoy premium Innova Crysta vehicles with experienced chauffeurs, clean interiors, ample luggage space, and reliable service for all wedding functions."
  },
  {
    "name": "Wedding Mercedes Car Rental Mumbai",
    "description": "Reserve Wedding Mercedes Car Rental Mumbai for an elegant and luxurious wedding entry with chauffeur-driven Mercedes vehicles. Make your special occasion unforgettable with premium comfort, stylish appearance, and first-class wedding transportation."
  },
  {
    "name": "Wedding Event Car Service Mumbai",
    "description": "Choose Wedding Event Car Service Mumbai for complete transportation arrangements during engagements, weddings, receptions, sangeet, mehendi, and other celebration events. Get luxury cars, premium SUVs, Innova Crysta, Tempo Travellers, and professional chauffeurs with customized wedding travel packages."
  }
],
"tableData": [
  ["Wedding Car Rental Mumbai", "Wedding Car Hire Mumbai"],
  ["Marriage Car Rental Mumbai", "Wedding Car Booking Mumbai"],
  ["Luxury Wedding Car Rental Mumbai", "Bridal Car Rental Mumbai"],
  ["Groom Car Rental Mumbai", "Wedding Taxi Service Mumbai"],
  ["Wedding Chauffeur Service Mumbai", "Premium Car Rental Mumbai"],
  ["Luxury Car Hire Mumbai", "Wedding Transportation Service Mumbai"],
  ["Wedding Innova Rental Mumbai", "Wedding Mercedes Car Rental Mumbai"],
  ["Wedding Event Car Service Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Elegant Wedding Car Rental in Mumbai",
    WhyChoosedescription: "Celebrate your special day in style with Shreesha Tours & Travels. Our wedding car rental service in Mumbai offers premium vehicles for the bride, groom, family members, and wedding guests, ensuring comfortable and memorable transportation."
  },
  {
    WhyChooseheading: "Luxury & Premium Cars for Grand Weddings",
    WhyChoosedescription: "Choose from premium Sedans, SUVs, Innova Crysta, luxury cars, and spacious Tempo Travellers to match your wedding theme, guest count, and travel requirements."
  },
  {
    WhyChooseheading: "Perfect Transportation for Every Wedding Event",
    WhyChoosedescription: "Book wedding cars for engagements, mehendi ceremonies, sangeet nights, haldi functions, wedding receptions, airport pickups for guests, and destination wedding travel."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Special Occasions",
    WhyChoosedescription: "Our experienced and well-dressed chauffeurs ensure punctual arrivals, courteous service, and smooth transportation throughout your wedding celebrations."
  },
  {
    WhyChooseheading: "Flexible Rental Packages for Weddings",
    WhyChoosedescription: "Choose hourly rentals, full-day packages, multiple vehicle bookings, guest transportation, or customized wedding travel plans according to your event schedule."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Wedding Fleet",
    WhyChoosedescription: "Every vehicle is regularly cleaned, air-conditioned, and maintained to provide a luxurious and comfortable travel experience for the bride, groom, and guests."
  },
  {
    WhyChooseheading: "Ideal for Local & Destination Weddings",
    WhyChoosedescription: "Whether your wedding is in Mumbai or at an outstation destination such as Lonavala, Alibaug, Pune, Nashik, Mahabaleshwar, or Goa, we provide reliable transportation services."
  },
  {
    WhyChooseheading: "Reliable Wedding Car Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Receive transparent pricing, dedicated booking assistance, and dependable service to make your wedding transportation smooth, stylish, and worry-free."
  }
]

};

const faqData = [
  {
    question: "Which vehicles are available for wedding car rental in Mumbai?",
    answer: "You can choose from Sedans, Ertiga, Innova, Innova Crysta, SUVs, luxury cars, Tempo Travellers, and other premium vehicles."
  },
  {
    question: "Can I rent multiple vehicles for wedding guests?",
    answer: "Yes, multiple cars, Tempo Travellers, and larger vehicles can be arranged for guest transportation and family members."
  },
  {
    question: "Do you provide wedding cars for destination weddings?",
    answer: "Yes, wedding transportation is available for destinations including Lonavala, Alibaug, Pune, Nashik, Mahabaleshwar, Goa, and many other locations."
  },
  {
    question: "Can I book a luxury car for the bride and groom?",
    answer: "Yes, premium vehicles are available for the bride and groom to make their special day even more memorable."
  },
  {
    question: "Do you provide airport pickup for wedding guests?",
    answer: "Yes, airport transfers can be arranged for wedding guests arriving at Mumbai Airport."
  },
  {
    question: "Can I hire wedding cars on an hourly basis?",
    answer: "Yes, hourly, half-day, full-day, and customized rental packages are available depending on your event schedule."
  },
  {
    question: "Are the drivers professionally trained for wedding events?",
    answer: "Yes, our chauffeurs are experienced, courteous, and ensure timely transportation throughout the wedding functions."
  },
  {
    question: "Can I decorate the wedding car?",
    answer: "Yes, decorative arrangements can be planned according to your preferences and event requirements."
  },
  {
    question: "How is the wedding car rental fare calculated?",
    answer: "The rental cost depends on the selected vehicle, rental duration, travel distance, event schedule, and any additional requirements."
  },
  {
    question: "How can I book a Wedding Car Rental in Mumbai with Shreesha Tours & Travels?",
    answer: "Share your wedding date, event locations, preferred vehicle, rental duration, and guest transportation requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Shah",
    feedback: "We booked multiple vehicles for our wedding functions through Shreesha Tours & Travels. Every car arrived on time, the chauffeurs were professional, and the entire transportation was managed perfectly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback: "The luxury wedding car looked beautiful, the ride was comfortable, and all our guests appreciated the excellent travel arrangements. Highly recommended for wedding transportation.",
    rating: 5
  }
];
















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Car Rental Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/wedding-car-rental-mumbai.webp",
  "description":
    "Book Wedding Car Rental Mumbai with Shreesha Tours & Travels for elegant, comfortable, and affordable wedding transportation services. We provide premium wedding cars, luxury sedans, SUVs, Innova Crysta, and chauffeur-driven vehicles for weddings, receptions, engagements, bridal entries, groom arrivals, and special occasions with 24x7 booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/wedding-car-rental-mumbai"
  }
};





    return (
        <div>
<Helmet>
  <title>Wedding Car Rental Mumbai | Luxury Marriage Cars | +91 8355835813</title>

  <meta
    name="description"
    content="Book Wedding Car Rental Mumbai with Shreesha Travels for luxury wedding and marriage car hire services. Choose premium chauffeur-driven cars for weddings, receptions, engagements, and bridal or groom entry with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Wedding Car Rental Mumbai, Wedding Car Hire Mumbai, Marriage Car Rental Mumbai, Wedding Car Booking Mumbai, Luxury Wedding Car Mumbai, Bridal Car Rental Mumbai, Groom Entry Car Mumbai, Chauffeur Driven Wedding Car Mumbai, Marriage Car Hire Mumbai, Wedding Innova Crysta Mumbai, Wedding SUV Rental Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Weddingcaerentalmumbai;